// extracted by mini-css-extract-plugin
module.exports = {"myPagesPage":"mypages_myPagesPage__eLb4y","titleWithIcon":"mypages_titleWithIcon__pRHYc"};